import React from "react";
import DebouncedInput from "components/DebounceInput";
import useFeatureFlag from "hooks/useFeatureFlag";
import { useTranslation } from "react-i18next";
import { IconFileCertificate } from "@tabler/icons-react";
import clsx from "clsx";
import { searchStore } from "features/ProductSearch/SearchStore";
import { observer } from "mobx-react-lite";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";
import CreateProductButton from "./CreateProductButton";
import ProductFilters from "../features/ProductFilters";
import { productSearchStore as store } from "../ProductSearchStore";

const HeaderRow = (props: { open?: boolean; searchBarStyle?: string }) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { isFeatureVisible } = useFeatureFlag();
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = React.useState(false);

  React.useEffect(() => {
    props?.open && inputRef.current?.focus();
  }, [props?.open]);

  function epdSearchLink() {
    return (
      <div className="flex">
        <span className="px-3 text-gray-600 hidden xl:block">
          {t("commons.or")}
        </span>
        <div
          className={clsx(
            "whitespace-nowrap text-indigo-700 hover:text-indigo-500 text-base font-medium cursor-pointer",
            "flex justify-between font-medium items-center"
          )}
          onClick={() => {
            searchStore.setOpenProductSearch({ state: false });
            searchStore.setOpenEPDSearch({
              state: true,
              term: store.searchInput.query ?? "",
            });
          }}
        >
          <IconFileCertificate className="mr-2" />
          {t("productEditor.searchEPDGenerateProduct")}
        </div>
      </div>
    );
  }

  const handleKeyPressed = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyA") {
      e.preventDefault();
      inputRef.current?.select();
    }
  };

  const onChangeSearch = (value: string | number) => {
    if (value === store.searchInput.query) return;
    store.updateSearchInput("query", String(value));
  };

  return (
    <div className="flex justify-between items-center pb-2 flex-col xl:flex-row">
      <div className="flex items-center w-full mb-3 xl:mb-0">
        <DebouncedInput
          ref={inputRef}
          containerClassName="mr-2 w-full"
          inputWrapperClassName="w-full"
          onChange={onChangeSearch}
          value={store.searchInput.query ?? ""}
          onKeyDown={handleKeyPressed}
        />

        <ProductFilters />
      </div>

      <div className="flex items-center w-full xl:w-auto justify-between">
        {isFeatureVisible("epds_in_product_search") &&
          !COEStore.openedSearchInCE &&
          epdSearchLink()}

        <CreateProductButton
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          canCreate={store.canCreate}
        />
      </div>
    </div>
  );
};

export default observer(HeaderRow);
